import { UserActions } from "./../states/user/user.actions";
import { AuthActions } from "./../states/auth/auth.actions";
import { NgModule } from "@angular/core";
import { AuthProvider } from "./auth/auth";
import { UserProvider } from "./user/user";
import { ConnectionProvider } from "./connection/connection";
import { ProjectProvider } from "./project/project";

@NgModule({
  declarations: [],
  imports: [],
  providers: [AuthProvider, UserProvider, ConnectionProvider, ProjectProvider, AuthActions, UserActions]
})
export class ProviderModule {}



// WEBPACK FOOTER //
// ./src/providers/provider.module.ts